import * as React from 'react';

type TooltipPosition = 'top' | 'left' | 'right' | 'bottom';

interface Props {
    tooltip?: React.ReactNode;
    position?: TooltipPosition;
    oneline?: boolean;
    instant?: boolean;
    clickable?: boolean;
    visible?: boolean;

    children: React.ReactNode;

    className?: string;
    style?: React.CSSProperties;
}

export default function Tooltip({
    tooltip,
    position,
    oneline,
    instant,
    clickable,
    visible,
    className,
    children,
    style,
}: Props) {
    const options = [
        position !== 'top' && position,
        oneline && 'oneline',
        instant && 'instant',
        clickable && 'clickable',
        visible && 'visible',
    ]
        .filter(Boolean)
        .join(' ');

    if (!tooltip) {
        return (
            <div className={className} style={style}>
                {children}
            </div>
        );
    }

    const tooltipString = typeof tooltip === 'string' ? tooltip : '';

    return (
        <div className={className} style={style} data-tooltip-options={options} data-tooltip={tooltipString}>
            {children}
            {!tooltipString && <div className="data-tooltip-content">{tooltip}</div>}
        </div>
    );
}
